// eslint-disable-next-line import/prefer-default-export
export function useLocalisation() {
  return window.localisation;
}
